import 'prop-types';
import styled from 'styled-components';

var CardDescription = styled.div.withConfig({
  displayName: "CardDescription",
  componentId: "sc-1sxpt7y-0"
})(["&&{color:", ";font-size:14px;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;}"], function (props) {
  return props.theme.neutralColors.smoke;
});

export { CardDescription };
